"use client";

import dynamic from "next/dynamic";

const VoiceCloning = dynamic(() => import("./VoiceCloning"));

export default VoiceCloning;
